export default class HUD {
  constructor() {
    this.root = document.getElementById("hud");
    if (!this.root) throw new Error("HUD root #hud not found");

    this.scoreEl = this.root.querySelector('[data-hud="score"]');
    this.highscoreEl = this.root.querySelector('[data-hud="highscore"]');
    this.overlayEl = this.root.querySelector('[data-hud="overlay"]');
    this.overlayTitleEl = this.root.querySelector('[data-hud="overlay-title"]');
    this.overlaySubtitleEl = this.root.querySelector('[data-hud="overlay-subtitle"]');
    this.overlayInstructionEl = this.root.querySelector('[data-hud="overlay-instruction"]');
    this.overlayButtonEl = this.root.querySelector('[data-hud="overlay-button"]');

    this._buttonHandler = null;
    this.overlayButtonEl.addEventListener("click", () => {
      if (this._buttonHandler) this._buttonHandler();
    });
  }

  setScore(value) {
    this.scoreEl.textContent = String(value);
  }

  setHighscore(value) {
    this.highscoreEl.textContent = String(value);
  }

  showOverlay({ title, subtitle, buttonLabel, onButton, instruction }) {
    this.overlayTitleEl.textContent = title || "";
    this.overlaySubtitleEl.textContent = subtitle || "";
    this.overlayInstructionEl.textContent = instruction || "";
    this.overlayButtonEl.textContent = buttonLabel || "";
    this.overlayButtonEl.style.display = buttonLabel ? "" : "none";
    this._buttonHandler = onButton || null;
    this.overlayEl.classList.remove("hidden");
    this.overlayEl.classList.add("flex");
  }

  hideOverlay() {
    this.overlayEl.classList.add("hidden");
    this.overlayEl.classList.remove("flex");
    this._buttonHandler = null;
  }
}
